module.exports = __webpack_public_path__ + "static/media/SmartShop_7-767w.38e369a9.webp";